import { getConstant } from '../utils';

export const getCalculatorsPrecedingCategory = getConstant('GET_CALCULATORS_PRECEDING_CATEGORY');
export const getCalculatorsPrecedingCategoryItem = getConstant('GET_CALCULATORS_PRECEDING_CATEGORY_ITEM');